import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Category'],
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/category',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Category'],
    }),
    addCategory: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-category',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Category'],
    }),
    updateCategory: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-category',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Category'],
    }),
    deleteCategory: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-category',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Category'],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
